<template>
  <b-container>
    <b-card class="panel">
    <Loading :active.sync="Loading"></Loading>
    <div class="controles">
      <h2>Reporte por operador</h2>
    </div>
    <div>
      <b-form-select class="select-operador" v-model="operador" :options="operadoresSelectList"></b-form-select>  
      <b-form-select class="select-tiempo" v-model="tiempo" :options="options"></b-form-select>
      <div v-if="tiempo === 1">
            <label for="datepicker-sm">Seleccione el día</label>
            <Vbdatapicker v-model="dia"  />
      </div>
      <div v-if="tiempo === 2">
            <label for="datepicker-sm">Seleccione la semana</label>
            <VbdatapickerWeek v-model="semana"  />
      </div>
      <div v-if="tiempo === 3">
            <label for="datepicker-sm">Seleccione el mes</label>
            <VbdatapickerMonth v-model="mes"  />
      </div>
      <div v-if="tiempo === 4"> 
            <label>Seleccione el año</label>
            <VbdatapickerYear v-model="anno"  />
      </div>
      <b-button class="generar"  @click="generar()">Generar</b-button>
    </div>   
   
      
    </b-card> 
    <b-card class="panel" v-if="arrData.length > 0">
  
        <b-table
            :items="reporte" 
            :fields="fields"
        >
            <template v-slot:cell(Contador)="row">
                <div v-if="row.item.Contador != null">
                {{ millar(row.item.Contador)}}
                </div>
            </template>
            <template v-slot:cell(Origen)="row">
                <div v-if="row.item.Origen != null">
                    {{ nombreMaquina(row.item.Origen)}}
                </div>

            </template>
        </b-table>
    </b-card> 
    <b-card class="panel"  v-else>
        <h2>Sin datos.</h2>
    </b-card> 
  </b-container>   
</template>

<script>
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import {mapActions, mapState, mapGetters} from 'vuex'
    import _ from 'lodash'
    
    import Vbdatapicker from '@/components/partials/vbdatapicker'
    import VbdatapickerWeek from '@/components/partials/vbdatapickerWeek'
    import VbdatapickerMonth from '@/components/partials/vbdatapickerMonth'
    import VbdatapickerYear from '@/components/partials/vbdatapickerYear'
    import moment from 'moment'
     import customMixin from '@/mixins/customMixin'
    export default {
        name:'Operador',
         mixins : [customMixin],
        components:{
            Loading,Vbdatapicker, VbdatapickerWeek, VbdatapickerMonth, VbdatapickerYear
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState(['Loading']),
            ...mapState('operador',['operadores','reporte']),

            
        },
        data:function () {
            return{
                tiempo: null,
                operador: null,
                options:[
                    {value: null, text: 'Seleccione la ventana de tiempo'},
                    {value: 1, text: 'Por día'},
                    {value: 2, text: 'Por semana'},
                    {value: 3, text: 'Por mes'},
                    {value: 4, text: 'Por año'},
                    ],
                operadoresSelectList:[],
                dia:null,
                semana:null,
                mes:null,
                anno:null,
                arrData:[],
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false
                },
                fields:[
                    { key: 'Origen', label: 'Maquina'},
                    
                    { key: 'Contador', label: 'Totales'},
                 
                    ]
            }            
        },
        methods:{
            ...mapActions({
                _fetchOperador: 'operador/fetchAll',
                _fetchOperadorDia: 'operador/reporteOperadorDia',
                _fetchOperadorSemana: 'operador/reporteOperadorSemana',
                _fetchOperadorMes : 'operador/reporteOperadorMes',
                _fetchOperadorAnno: 'operador/reporteOperadorAnno'
            }),
            init(){
                
                this._fetchOperador().then(() => {
                    let that = this//dentro del foreach no usar this.
                    _.forEach(this.operadores, function(value,key){
                        
                        let payload = {
                            value: value.nombre,
                            text:  value.nombre
                        }

                        that.operadoresSelectList.push(payload)
                    })  //_.forEach  
                })//then
            },//init
            generar(){
                if(this.tiempo === 1){
                    this.porDia()
                }
                if(this.tiempo === 2){
                    this.porSemana()
                }
                if(this.tiempo === 3){
                    this.porMes()
                }
                if(this.tiempo === 4){
                    this.porAnno()
                }
            },
            porDia(){
                let payload = {
                    'operador':  this.operador,
                    'dia' : this.dia
                }
                this.arrData = []//se limpia
                this._fetchOperadorDia(payload).then(()=>{
                    let that = this
                    _.forEach(this.reporte, function(value,key){
                        
                        let obj = {
                            'data':value.Contador, 
                            'label':value.Orden
                            
                        }
                      
                        that.arrData.push(obj)
                    })
                })
            },
            porSemana(){
                let payload = {
                    'operador':  this.operador,
                    'semana' : this.semana
                }
                this.arrData = []//se limpia
                this._fetchOperadorSemana(payload).then(()=>{
                    let that = this
                    _.forEach(this.reporte, function(value,key){
                        
                        let obj = {
                            'data':value.Contador, 
                            'label':value.Orden
                        }
                      
                        that.arrData.push(obj)
                    })
                })
            },
            porMes(){
                let mes = null
                let anno = null
                let partes = this.mes.toString().split(".")
                mes = partes[0]
                anno = partes[1]

                let payload = {
                    'operador':  this.operador,
                    'mes' : mes,
                    'anno' : anno
                }
                console.warn(payload)
                this.arrData = []//se limpia
                this._fetchOperadorMes(payload).then(()=>{
                    let that = this
                    _.forEach(this.reporte, function(value,key){
                        
                        let obj = {
                            'data':value.Contador, 
                            'label':value.Orden
                        }
                      
                        that.arrData.push(obj)
                    })
                })
            },
            porAnno(){
                let anno = moment(this.anno).year() 
                let payload = {
                    'operador':  this.operador,
                    'anno' : anno
                }
                this.arrData = []//se limpia
                this._fetchOperadorAnno(payload).then(()=>{
                    let that = this
                    _.forEach(this.reporte, function(value,key){
                        
                        let obj = {
                            'data':value.Contador, 
                            'label':value.Orden
                        }
                      
                        that.arrData.push(obj)
                    })
                })
            }
        }
        
    }
</script>

<style lang="scss" scoped>
.controles{
    display:flex;
    margin-top:1em;
    align-items: center;
}
h2{
    align-self:center;
    font-size: 1.5em;
    margin-bottom:0.5em;
}

.panel{
      margin-top:1em;
    }
.generar {
    margin-top:0.5em;
}
.select-operador{
    margin-top:0.5em;
}
.select-tiempo{
    margin-top:0.5em;
}
@media screen and (max-width: 576px) {
    .controles{
        flex-direction: column;
        padding:0;
        margin:0;
        
    }
    
}
</style>